<template>
  <el-main class="common-main">
    <div class="container">
      <el-row class="tac" :gutter="20">
        <el-col :span="4">
          <TheLeft></TheLeft>
        </el-col>
        <el-col :span="20">
          <div class="order-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="全部订单" name="0"></el-tab-pane>
              <el-tab-pane label="待付款" name="1"></el-tab-pane>
              <el-tab-pane label="已完成" name="2"></el-tab-pane>
              <el-tab-pane label="已取消" name="3"></el-tab-pane>
            </el-tabs>
            <div class="order-box" v-loading="loading">
              <div class="order-list" v-if="orders.length > 0">
                <div class="order-item" v-for="(item, index) in orders" :key="index">
                  <div class="order-item-header">
                    <div>订单号：{{ item.no }}</div>
                    <div>{{ item.created_at }}</div>
                  </div>
                  <div class="order-item-content">
                    <div v-for="(i, n) in item.items" :key="n" class="order-item-content-i">
                      <el-row :gutter="20">
                        <el-col :span="4">
                          <img :src="i.study.images && i.study.images.length > 0 ? path + i.study.images[0] : noneImg"
                               :alt="i.study.title" class="cart-item-img">
                        </el-col>
                        <el-col :span="10">
                          <router-link :to="{path: '/course/'+i.study.id}" class="cart-item-title">
                            {{ i.study.title }}
                          </router-link>
                        </el-col>
                        <el-col :span="6">
                          <div class="cart-item-title">{{ i.course.title }}</div>
                        </el-col>
                        <el-col :span="4">
                          <div class="cart-item-price">¥ {{ i.study.o_price }}</div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="order-item-footer">
                    <div>
                      <span>订单金额：</span>
                      <span class="cart-item-price">¥ {{ item.total_amount }}</span>
                    </div>
                    <div class="order-item-footer-button">
                      <div class="order-item-footer-status">
                        <span class="color-danger" v-if="!item.paid_at && !item.closed">待付款</span>
                        <span v-if="!item.paid_at && !item.closed && item.payment_method === 'bank'">汇款后请联系老师确认</span>
                      </div>
                      <div class="order-item-footer-btn">
                        <el-button type="primary" v-if="!item.paid_at && !item.closed" @click="goPay(item.id)">
                          <span v-if="item.payment_method !== 'bank'">去支付</span>
                          <span v-if="item.payment_method === 'bank'">银行汇款</span>
                        </el-button>
                        <span v-if="item.paid_at || item.closed" class="order-item-delete" @click="deleteOrder(index)">删除订单</span>
                        <el-button v-if="item.paid_at" disabled>已完成</el-button>
                        <el-button v-if="item.closed" disabled>已取消</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty" v-if="page_meta.total === 0">
                <div>
                  <img src="../../static/images/empty.png" alt="暂无数据" class="empty-img">
                  <div class="empty-title">暂无数据</div>
                </div>
              </div>
            </div>
            <div class="list-pagination" v-if="orders.length > 0">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="page_meta.per_page"
                  :total="page_meta.total">
              </el-pagination>
            </div>
            <div class="my-ask">
              <el-button type="default" size="mini" @click="clearOrder">清空订单</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
import TheLeft from "@/components/layouts/TheLeft";
import {authRequest} from "@/utils/request";

export default {
  name: "userOrder",
  head: {
    title: "我的订单"
  },
  components: {
    TheLeft
  },
  data() {
    return {
      activeName: '0',
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      orders: [],
      page: 1,
      page_meta: [],
      loading: false
    }
  },
  created() {
    this.getOrders(true)
  },
  methods: {
    handleClick(tab, event) {
      this.getOrders(true)
    },
    async getOrders(reset = false) {
      this.loading = true
      if (reset) {
        this.page = 1
      }
      try {
        let response = await authRequest('user/order', {
          method: 'GET',
          params: {
            page: this.page,
            type: this.activeName
          }
        })
        let orders = response.data
        this.orders = orders.data
        this.page_meta = orders.meta
        this.loading = false
      } catch (e) {

      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getOrders()
    },
    goPay(id) {
      this.$router.push({path: '/pay/' + id})
    },
    deleteOrder(index) {
      let id = this.orders[index].id
      this.$confirm('您确定要删除该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await authRequest('order/' + id, {
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          this.orders.splice(index, 1)
        } catch (e) {

        }
      }).catch(() => {

      });
    },
    clearOrder() {
      this.$confirm('您确定要清除所有订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await authRequest('order/clear/all', {
            method: 'POST'
          })
          this.$message.success('清除成功')
          this.getOrders()
        } catch (e) {

        }
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.order-content {
  background-color: #ffffff;
  padding: 10px 20px;
  position: relative;
}

.order-item {
  border: 1px solid #ebebeb;
  margin-bottom: 20px;
  border-radius: 5px;
}

.order-item-header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
  background-color: #f3f3f3;
}

.order-box {
  min-height: 400px;
}

.order-item-content {
  padding: 20px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
}

.cart-item-img {
  width: 120px;
  height: 70px;
  object-fit: cover;
  border-radius: 5px;
}

.cart-item-price {
  color: #f44848;
  font-size: 18px;
}

.order-item-content-i {
  margin-bottom: 20px;
}

.order-item-content-i:last-child {
  margin-bottom: 0;
}

.order-item-footer {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
}

.order-item-footer-button {
  display: flex;
  align-items: center;
}

.order-item-footer-btn {
  margin-left: 20px;
}

.order-item-footer-status span {
  margin-left: 20px;
}

.order-item-delete{
  margin-right: 10px;
  font-size: 13px;
  color: #555555;
  cursor: pointer;
}

.order-item-delete:hover{
  color: #F56C6C;
}

.my-ask {
  position: absolute;
  right: 20px;
  top: 10px;
}
</style>
